module.exports = __webpack_public_path__ + "static/CalibreWeb-Regular-05764c34a1db671fc26a178c80d69b6d.woff";